import { Close } from '@uikit/icons/Close';

import { namedErrors } from '@shared/constants';

export interface MagicSwapFailureViewProps {
  txError?: Error;
  createNewSwap: () => void;
}

const MagicSwapFailureView = ({ txError, createNewSwap }: MagicSwapFailureViewProps) => {
  return (
    <div className="flex flex-col w-full items-center justify-center">
      <h3 className="mb-[72px] text-[28px] font-semibold">Transaction failed</h3>

      <div className="rounded-full w-[100px] aspect-square flex-shrink-0 p-2 flex items-center justify-center bg-red-600 mb-[48px]">
        <Close className="icon-[70px] text-neutral-50" />
      </div>

      <p className="text-neutral-400 overflow-auto max-w-full break-words">
        {txError?.message || namedErrors.DEFAULT_RETRY_OR_CONTACT_SUPPORT}
      </p>

      <button
        className="w-full button button-lg button-secondary mt-[64px] h-[54px] text-lg gap-3"
        onClick={createNewSwap}
      >
        Create New Swap
      </button>
    </div>
  );
};

export default MagicSwapFailureView;
